export const json = {
  parse: (text: string) => {
    try {
      return JSON.parse(text)
    } catch {
      return null
    }
  },
  stringify: (value: any) => {
    try {
      return JSON.stringify(value)
    } catch {
      return null
    }
  }
}
